<div class="textRecordsContainer">
    <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span>
    <div class="header hdr">
        <h5><span class="animateH5">Text Analytics</span></h5>
    </div>
    <div class="container-fluid text-record-main">
        <!-- <div class="col-md-12 text-center SurveyTag">
                <ul class="nav nav-pills nav-justified">
                    <li class="nav-item text-record-tabs">
                        <a class="nav-link active" (click)="openDoc('pdf')" role="tab" data-bs-toggle="tab"
                            data-bs-target="#pdf" aria-current="page" href="#">PDF</a>
                    </li>
                    <li class="nav-item text-record-tabs">
                        <a class="nav-link" (click)="openDoc('text')" role="tab" data-bs-toggle="tab"
                            data-bs-target="#text" href="#">Text</a>
                    </li>
                     <li class="nav-item text-record-tabs">
                        <a class="nav-link" role="tab" (click)="openDoc('emailTable')" data-bs-toggle="tab"
                            data-bs-target="#emailTable" href="#">Email Analytics</a>
                    </li>  
                </ul>
        </div> -->
        <!-- pdf -->
        <div class="pdfRecords">
         
            <div class="table-responsive">
                <div class="card tblCrd">
                    <table class="table text-center" id="audioTable">
                        <thead class="tblHead">
                            <tr>
                                <th class="callLogHead">Category</th>
                                <th>Sentiment</th>
                                <th>Summarization</th>
                                <th>Record</th>
                                <th>QA</th>
                                <!-- <th class="progressHead">keyword match</th>
                                <th class="progressHead">QA MATRICS</th> -->
                                <!-- <th class="progressHead">MODULATION PERCENTAGE</th> -->
                                
                                <!-- <th class="">REPORT</th> -->
                                <th class="timeTh">uploaded date
                                    <!-- <i class="fa fa-sort-asc" *ngIf="!sortingShow" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" *ngIf="sortingShow" aria-hidden="true"></i> -->
                                </th>
                                <th class="action">action</th> 
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngIf="textTableData.length === 0 && !bodySpinner">
                                <td colspan="14">
                                    <p class="noRecord">No Records Found</p>
                            </tr>
                            <tr *ngFor="let result of textTableData | paginate :{itemsPerPage:limit,
                            currentPage:page,
                            totalItems:textTableRecords.total}; index as i" (click)="tableBack(i)"
                                [ngClass]="{'selectedClass':i===tableTrVar, 'unread': result.read==='N'}">
                                <td class="callLogTd">
                                    <span class="callLogs">
                                        {{result.category}}
                                    </span>
                                </td>
                                   <td>
                                    <i class="fa-regular fa-face-meh audioIcons iconMeh" *ngIf="result.sentiment=='Neutral'"
                                    tooltip="View Sentiment" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#sentimentModal"
                                    (click)="getSentimentFun(i)" ></i>
                                        <i class="fa-regular fa-face-smile audioIcons iconSmile" *ngIf="result.sentiment=='Positive'"
                                    tooltip="View Sentiment" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#sentimentModal"
                                    (click)="getSentimentFun(i)"  ></i>
                                        <i class="fa-regular fa-face-frown audioIcons iconSad" *ngIf="result.sentiment=='Negative'"
                                        tooltip="View Sentiment" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)"    ></i>
                                        
                                </td>
                                <td>
                                    <span  tooltip="View Summary" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#textSummaryModal"
                                    (click)="getTextSummaryFun(i)" > <i class="bi bi-file-text"></i></span>
                                </td>
                                <td><span  tooltip="View Records" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#rowrecordsModal"
                                    (click)="getRowRecords(i)" > <i class="bi bi-file-text"></i></span></td>

                              <td>
                                    <ng-container *ngIf="result['question_answer'][0]['qa_pairs'].length==0 else questionAnswer">
                                         <span> - </span>
                                    </ng-container>
                                    <ng-template #questionAnswer>

                                          <span class="position-relative" data-bs-toggle="modal"
                                    data-bs-target="#qaModal" (click)="showQADetails(result,i)">
                                    <i class="fa fa-file-lines audioIcons iconFile"  
                                    tooltip="View Q/A Details" [options]="myOptions" 
                                    ></i>
                                    <ng-containet *ngIf="result['question_answer'][0]['qa_pairs'].length==0 else qadata">

                                    </ng-containet>
                                    <ng-template #qadata>
                                         <span   class="badge" (click)="showQADetails(result,i)" style="position: absolute;bottom:-9px;left:20px;background: #1587f4;">{{result['question_answer'][0]['qa_pairs'].length}}</span>
                                    </ng-template>
                                   
                                    </span>
                                        
                                    </ng-template>
                                  
                                  
                                    </td>
                                
                                <!-- <td class="progressTd">
                                  
                                </td> -->
                                <!-- <td class="progressTd">
                                    <div class="progress">
                                        <div class="progress-bar" [ngClass]="{'progress-bar0': result.metric_percentage == 0, 
                                'progress-barGreen':result.metric_percentage > 74, 
                                'progress-barRed':result.metric_percentage > 0 && result.metric_percentage < 50}"
                                            role="progressbar" attr.aria-valuenow="{{result.metric_percentage}}"
                                            aria-valuemin="0" aria-valuemax="100"
                                            attr.style="width:{{result.metric_percentage}}%">
                                            {{result.metric_percentage | number:'1.0-0'}}%
                                        </div>
                                    </div>
                                    <i class="fa fa-eye" aria-hidden="true" tooltip="View Metric Details"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#qaMetricsModal"
                                        (click)="getQAMetricsData(i)"></i>
                                </td> -->
                                <!-- <td class="progressTd">
                                    <div class="progress">
                                        <div class="progress-bar"
                                            [ngClass]="{'progress-bar0': result.pause_score == 0,'progress-bar-minus': result.pause_score < 0 ,
                                 'progress-barGreen':result.pause_score > 74, 'progress-barRed':result.pause_score > 0 && result.pause_score < 50}"
                                            role="progressbar" attr.aria-valuenow="{{result.pause_score}}"
                                            aria-valuemin="0" aria-valuemax="100"
                                            attr.style="width:{{result.pause_score}}%">
                                            {{result.pause_score | number:'1.0-0'}}%
                                        </div>
                                    </div>
                                    <i class="fa fa-eye" aria-hidden="true" tooltip="View Modulation Details"
                                        [options]="myOptions" (click)="CallCategoryIndex(i)" data-bs-toggle="modal"
                                        data-bs-target="#modulationModal">
                                    </i>
                                </td> -->
                                <!-- <td>
                                    <i class="fa fa-file-text audioIcons iconFile" data-bs-toggle="modal"
                                        data-bs-target="#transcriptModal" tooltip="View Transcript"
                                        [options]="myOptions" (click)="modalHeading('dialogue')"
                                        (click)="hideMinimizedModal('Transcript')"
                                        (click)="getTranscriptFun(i, 'transcript')"></i> 
                                </td>-->
                                <!-- <td><i class="fa-regular fa-file audioIcons iconFile"
                                        tooltip="View Review/Analysis Report" [options]="myOptions"
                                        data-bs-toggle="modal" data-bs-target="#reportModal"
                                        (click)=" getReportData(i, 'report')"></i>
                                </td> -->
                                <td class="timeTd">{{result.uploaded_date | date:'MM/dd/yyyy'}}</td>
                                 <td class="actionTd">
                                  <!--  <i class="fa fa-language audioIcons iconAction" aria-hidden="true"
                                        tooltip="Translate" [options]="myOptions" data-bs-toggle="modal"
                                        data-bs-target="#translateModal" (click)="getTranslateDataFun_1(i)"></i>
                                     <i class="fa-solid fa-download audioIcons iconAction" *ngIf="i!==getDownloadIndex"
                                        tooltip="Download Report" [options]="myOptions"
                                        (click)=" getReportData(i,'download')"></i>  
                                    <i class="fa-solid fa-download audioIcons iconAction" tooltip="Download Report"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#reportModal"
                                        (click)=" getReportData(i, 'report')"></i>
                                    
                                    <i class="fa-solid fa-circle-info audioIcons iconAction" tooltip="File Info"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#RecordDeleteModal"
                                        (click)="getInfoData(i)"></i>  -->
                                    <i class="fa-regular fa-trash-can audioIcons iconAction" tooltip="Delete Record"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                        (click)="getIndex(i)" *ngIf="usersRole !== 101"></i>  
                                </td> 
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="paginationRecords" *ngIf="textTableData.length > 0">
                 <div class="d-flex align-items-center">
                <span class="col-md-6 pagination-records">
                    Showing {{textTableData.length}} of {{textTableRecords.total}} records
                </span>
                <span class="col-md-6 pull-right">
                     
                        <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                            [directionLinks]="true" (pageChange)="pageChanged($event)">

                        </pagination-controls>
                   
                </span>
            </div>
                <!-- <div class="row">
                    <div class="col-md-6 pagination-records">
                        <p>Showing {{textTableData.length}} of {{textTableRecords.total}} records</p>
                    </div>
                    <div class="col-md-6 text-right">
                        
                            <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                                [directionLinks]="true" (pageChange)="pageChanged($event)">

                            </pagination-controls>
                        
                    </div>
                </div> -->
            </div>
        </div>
    
    </div>
    <!-- minimize modal -->
    <div class="minimized-transcript-modal" *ngIf="transcriptMinimizedBoolean">
        <div class="modal-header">
            <h4 class="modal-title">{{transcriptMinimizedHeader}}</h4>
            <div class="modal-header-second-part">
                <i class="fa-solid fa-maximize min-max-icon" data-bs-toggle="modal" data-bs-target="#transcriptModal"
                    (click)="hideMinimizedModal('Transcript')" tooltip="Maximize" [options]="myOptions"></i>
                <i class="fa-solid fa-xmark exitIcon close " tooltip="Close" [options]="myOptions"
                    (click)="clearKeywordDetailsTranscriptModal()" aria-label="Close"
                    (click)="hideMinimizedModal('Transcript')"></i>
            </div>
        </div>
    </div>
    <!-- Modal window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="transcriptModal">
        <div class="modal-dialog modal-dialog-scrollable modal-xl {{modalScreenSize}} transcriptModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Transcript</h4>
                    <div class="modal-header-second-part">
                        <i class="fa-solid fa-window-minimize min-max-icon" title="Minimize"
                            (click)="showMinimizedModal('Transcript')" data-bs-dismiss="modal" aria-label="Close"></i>
                        <i class="fa-solid fa-up-right-and-down-left-from-center min-max-icon" title="Full Screen"
                            *ngIf="!modalScreenSize" (click)="modalFullScreen('max')"></i>
                        <i class="fa-solid fa-down-left-and-up-right-to-center min-max-icon" title="Restore Down"
                            *ngIf="modalScreenSize" (click)="modalFullScreen('min')"></i>
                        <i class="fa-solid fa-xmark exitIcon close " title="Close"
                            (click)="clearKeywordDetailsTranscriptModal()" data-bs-dismiss="modal"
                            aria-label="Close"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-pills nav-justified border-bottom modalTitileTab" role="tablist">
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'dialogue'}" href="#nav-dialogue"
                                data-bs-toggle="tab" id="dialogue" role="tab" (click)="modalHeading('dialogue')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')" aria-current="page">Dialogue</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'keyword'}" href="#nav-keyword"
                                #keywordId data-bs-toggle="tab" id="keyword" role="tab"
                                (click)="modalHeading('keyword')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Keyword/Phrases</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'alertKeywords'}"
                                href="#nav-alertKeywords" data-bs-toggle="tab" role="tab" id="alertKeywords"
                                (click)="modalHeading('alertKeywords')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Alert Keywords</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'questions'}" href="#nav-questions"
                                data-bs-toggle="tab" role="tab" id="questions" (click)="modalHeading('questions')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Questions</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'summary'}" href="#nav-summary"
                                data-bs-toggle="tab" role="tab" id="summary" (click)="modalHeading('summary')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Summary</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'mostUsedWords'}"
                                href="#nav-mostUsedWords" data-bs-toggle="tab" role="tab" id="mostUsedWords"
                                (click)="modalHeading('mostUsedWords')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Most Used Words</a>
                        </li>
                        <li class="nav-item border-bottom border-2 modalTitile" *ngIf="showData === 'pdf' ">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'textEntities'}"
                                href="#nav-textEntities" data-bs-toggle="tab" role="tab" id="textEntities"
                                (click)="modalHeading('textEntities')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Text Entities</a>
                        </li>
                    </ul>
                    <div class="modal-subtitle modal-subtitle2 border-bottom">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'dialogue'">
                                        Dialogue</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'transcript'">Transcript</h4>
                                    <h4 class="tabContentHeading"
                                        *ngIf="showModal === 'keyword' && !spinner && showData !== 'emailTable'">
                                        Keyword/Phrases
                                        {{" - Keyword Percentage - "+"( "+(questionsData_T[0]?.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <h4 class="tabContentHeading"
                                        *ngIf="showModal === 'keyword' && !spinner && showData === 'emailTable'">
                                        Keyword/Phrases
                                        {{" - Keyword Percentage - "+"( "+(questionsData_T?.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'alertKeywords'">Alert
                                        Keywords
                                    </h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'questions'">Questions</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'summary'">Summary</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'mostUsedWords'">Most Used
                                        Words
                                    </h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'textEntities'">Text Entities
                                    </h4>
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable_T"
                                        name="" id="" class="form-select lg-select-transcript"
                                        *ngIf="showSelect_T && !spinner">
                                        <option *ngFor="let lg of transcribedLg_T" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Dialogue Contents -->
                    <div class="tab-content">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'dialogue','show':showModal === 'dialogue'}"
                            id="nav-dialogue" *ngIf="!spinner">
                            <p *ngIf="showData == 'emailTable' && emailData[fileIndex]?.emaildate"
                                class="emailTranscriptHeading3 text-end"><b>{{emailData[fileIndex]?.emaildate}}</b>
                            </p>
                            <p *ngIf="showData == 'emailTable' && emailData[fileIndex]?.emailsubject"
                                class="emailTranscriptHeading2"><b>{{emailData[fileIndex]?.emailsubject}}</b></p>
                            <div class="transcriptTab emailTableTranscriptTab"
                                *ngIf="dialogueList_T?.[0] && showData == 'emailTable' && emailData[fileIndex]?.emailfrom ">
                                <span><b>From: </b> {{emailData[fileIndex]?.emailfrom}}</span>
                            </div>
                            <div class="transcriptTab email-transcriptTab"
                                *ngIf="dialogueList_T?.[0] && showData == 'emailTable' && emailData[fileIndex]?.emailto.length > 0 ">
                                <b>To: </b>
                                <ul class="emailTableTranscriptTab"
                                    *ngFor="let to of emailData[fileIndex]?.emailto; index as to_i">
                                    <span> {{to}}</span>
                                </ul>
                            </div>
                            <div class="transcriptTab email-transcriptTab"
                                *ngIf="dialogueList_T?.[0] && showData == 'emailTable' && emailData[fileIndex]?.cc.length > 0">
                                <b>CC: </b>
                                <ul class="emailTableTranscriptTab"
                                    *ngFor="let cc of emailData[fileIndex]?.cc; index as cc_i">
                                    <span> {{cc}}</span>
                                </ul>
                            </div>
                            <div class="transcriptTab" *ngIf="dialogueList_T?.[0]">
                                <ul class="ulTranscript-textRecords" *ngFor="let dialog of dialogueList_T ; index as i;"
                                    [appHighlight]="searchText">
                                    <li class="keywordLi">{{dialog}}</li>
                                </ul>
                            </div>
                            <div class="transcriptTab" *ngIf="!dialogueList_T?.[0]">
                                <p class="noRecord text-center">No records found</p>
                            </div>
                        </div>
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'keyword','show':showModal === 'keyword'}"
                            id="nav-keyword" *ngIf="!spinner">
                            <!--Keyword/Phrases-->
                            <div class="keywordTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul *ngFor="let keyword of keywordPhrases_T ; index as i;" [appHighlight]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="keywordTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul *ngFor="let keyword of keywordPhrases_T ; index as i;" [appHighlight]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- AlertKeyword -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'alertKeywords','show':showModal === 'alertKeywords'}"
                            id="nav-alertKeywords" *ngIf="!spinner">
                            <div class="alertkeywordTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul class="border-bottom" *ngFor="let keyword of alertkeywordList_T ; index as i;"
                                    [appHighlight]="searchText">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="alertkeywordTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul class="border-bottom" *ngFor="let keyword of alertkeywordList_T ; index as i;"
                                    [appHighlight]="searchText">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- question tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'questions','show':showModal === 'questions'}"
                            id="nav-questions">
                            <div class="questionTab2" *ngIf="englishQuestions_T?.length == 0">
                                <p class="noRecord">No Records Found</p>
                            </div>
                            <div class="questionTab" *ngIf="englishQuestions_T?.length > 0">
                                <table>
                                    <tbody>
                                        <tr *ngFor="let question of englishQuestions_T ; index as i;"
                                            [appHighlight]="searchText">
                                            <td class="numberTd">{{i+1}}.</td>
                                            <td>
                                                <p class="answerPara">
                                                    <b>{{"Q : "}}</b>
                                                    {{question.question}}
                                                </p>
                                                <p> <b>{{"A : "}}</b>
                                                    {{question.answer}}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- summary tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'summary','show':showModal === 'summary'}"
                            id="nav-summary" *ngIf="!spinner">
                            <div class="summaryTab">
                                <p *ngFor="let sum of keywordSummary_T;" [appHighlight]="searchText">{{sum}}</p>
                                <p class="noRecord text-center" *ngIf="!keywordSummary_T?.length">No records found
                                </p>
                            </div>
                        </div>
                        <!-- most used words tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'mostUsedWords','show':showModal === 'mostUsedWords'}"
                            id="nav-mostUsedWords" *ngIf="!spinner">
                            <div class="mostUsedWordTab">
                                <p class="data" *ngFor="let word of mostUsedWords_T ; index as i;"
                                    [appHighlight]="searchText">
                                    {{i+1}}.
                                    {{word.word}}
                                    ({{word.count}})</p>
                                <p class="noRecord text-center" *ngIf="!mostUsedWords_T?.length">No records found
                                </p>
                            </div>
                        </div>
                        <!--  text entities tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'textEntities','show':showModal === 'textEntities'}"
                            id="nav-textEntities" *ngIf="!spinner">
                            <div class="col-md-12 text-entities-button-class"
                                *ngIf="transcribedLgVariable_T === 'English' ">
                                <button class="btn btn-primary updateBtn"
                                    (click)="DownloadEntityData()">Download</button>
                            </div>
                            <div class="mostUsedWordTab">
                                <div *ngIf="transcribedLgVariable_T === 'English' ">
                                    <p class="data" *ngFor="let result of textEntitiesResult_T ; index as i;"
                                        [appHighlight]="searchText">
                                        {{result.propertyKey + " : "}} {{result.propertyValue}}
                                    </p>
                                    <p class="noRecord text-center" *ngIf="!textEntitiesResult_T?.length">No records
                                        found
                                    </p>
                                </div>
                                <div class="noRecord text-center" *ngIf="transcribedLgVariable_T !== 'English' ">No
                                    records found</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Keyword Percentage Modal Window -->
    <div class="modal fade" id="keywordPercentageModal" tabindex="-1" aria-labelledby="keywordPercentageModal"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="keywordPercentageModalLabel">Keyword Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="modal-subtitle border-bottom">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                    <h4 class="tabContentHeading" *ngIf="!spinner">Keyword/Phrases
                                        {{"( "+ (questionsData[0]?.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable"
                                        name="" id="" class="form-select lg-select-transcript" *ngIf="showSelect">
                                        <option *ngFor="let lg of transcribedLg" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="nav-keyword" *ngIf="!spinner">
                        <!--Keyword/Phrases-->
                        <div class="keywordTab">
                            <ul *ngFor="let keyword of keywordPhrases | search: searchText; index as i">
                                <li class="keywordLi" *ngIf="transcribedLgVariable === 'English' ">
                                    {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                <li class="matchesLi" *ngIf="transcribedLgVariable === 'English' ">
                                    {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                        No matches were found for keyword -
                                        "{{keyword.keyword}}"</p>
                                </li>
                                <li class="keywordLi" *ngIf="transcribedLgVariable !== 'English' ">
                                    {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                <li class="matchesLi" *ngIf="transcribedLgVariable !== 'English' ">
                                    {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                        class="text-center">No matches were found for keyword -
                                        "{{keyword.spanish_keyword}}"</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- QA Metrics Modal Window -->
    <div class="modal fade" id="qaMetricsModal" tabindex="-1" aria-labelledby="qaMetricsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="qaMetricsModalLabel">Metric Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"
                        (click)="clearModalData()"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Metric Details (Metric Percentage - {{getMetricPercentage | number:'1.0-0'}}%)</p>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colspan="3" class="text-center"></th>
                                            <th colspan="3" class="text-center">Machine Scores based on QA Metric
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Category</th>
                                            <th>Score</th>
                                            <th>Keywords</th>
                                            <th>Agent Score</th>
                                            <th>Percentage (%)</th>
                                            <th>Matched Keywords</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center" *ngIf="metricsMatches.length === 0">
                                            <td colspan="8">
                                                <p class="noRecord">No Records Found</p>
                                        </tr>
                                        <tr *ngFor="let call of metricsMatches; index as i">
                                            <td>{{call?.category}}</td>
                                            <td>{{call?.score}}</td>
                                            <td>{{call?.keywords}}</td>
                                            <td>{{call?.agent_score}}</td>
                                            <td>{{call?.matched_percentage | number:'1.0-1'}}%</td>
                                            <td>{{call?.matched_keywords}}
                                                <p class="text-center" *ngIf="!call?.matched_keywords.length">-</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modulation Modal Window -->
    <div class="modal fade" id="modulationModal" tabindex="-1" aria-labelledby="modulationModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="modulationModalLabel">Modulation Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p *ngIf="this.showData === 'pdf'">Modulation Details (Modulation Percentage -
                                {{tableData[callCategoryIndex]?.pause_score |
                                number:'1.0-0'}}%)</p>
                            <p *ngIf="this.showData === 'text'">Modulation Details (Modulation Percentage -
                                {{textTableData[callCategoryIndex]?.pause_score |
                                number:'1.0-0'}}%)</p>

                        </div>
                        <div class="card-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2">Negative Modulation</th>
                                    </tr>
                                    <tr>
                                        <th>Word</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="modulationData?.negative?.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let call of modulationData?.negative; index as i">
                                        <td>{{call?.word}}</td>
                                        <td>{{call?.score | number:'1.1'}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2">Positive Modulation</th>
                                    </tr>
                                    <tr>
                                        <th>Word</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="modulationData?.positive?.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let call of modulationData?.positive; index as i">
                                        <td>{{call?.word}}</td>
                                        <td>{{call?.score | number:'1.0-1'}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Record Info Edit Modal Window -->
    <!-- <div class="modal fade" id="RecordDeleteModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="RecordDeleteModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" *ngIf="showData === 'pdf' " id="RecordDeleteModalLabel">PDF Details</h4>
                    <h4 class="modal-title" *ngIf="showData === 'text' " id="RecordDeleteModalLabel">Text Details
                    </h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearRecordData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="infoHeading d-flex border-bottom">
                        <p class="infoFirst"> <b>Details</b></p>
                        <button class="btn infoSecond" (click)="editInfoDetails()">
                            <i *ngIf="!infoEditShow" class="fa-regular fa-pen-to-square" tooltip="Edit Info"
                                [options]="myOptions"></i>
                            <i *ngIf="infoEditShow" class="fa fa-arrow-left" aria-hidden="true" tooltip="Back"
                                [options]="myOptions"></i>
                        </button>
                    </div>
                    <form [formGroup]="infoForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"><b>Display Name</b><i
                                                class="fa-solid fa-asterisk mandatoryIcon"
                                                *ngIf="infoEditShow"></i></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetails?.display_file_name}}</p>
                                    <input *ngIf="infoEditShow" formControlName="display_file_name"
                                        name="display_file_name" id="display_file_name" type="text"
                                        class="form-control">
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['display_file_name'].invalid && infoForm.controls['display_file_name'].dirty && infoForm.hasError('required','display_file_name')">
                                        Display name is Required.
                                    </span>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Topics</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoTopicsName}}</p>

                                    <ng-select *ngIf="infoEditShow" formControlName="topic" dropdownPosition="auto"
                                        name="topic" id="topic" placeholder="Choose/Search topic" [clearable]="false">
                                        <ng-option [value]="info.id?.$oid" title="{{info?.id?.$oid}}"
                                            *ngFor="let info of getInfoTopics; index as i">{{info?.topic}}</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Your Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.own_key_words">{{infoDetails?.own_key_words}}</span>
                                        <span *ngIf="!infoDetails?.own_key_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="own_key_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="own_key_words"
                                        name="own_key_words" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Alert Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.alert_keywords">{{infoDetails?.alert_keywords}}</span>
                                        <span *ngIf="!infoDetails?.alert_keywords?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="alert_keywords"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="alert_keywords"
                                        name="alert_keywords" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Sensitive Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span
                                            *ngIf="infoDetails?.sensitive_words">{{infoDetails?.sensitive_words}}</span>
                                        <span *ngIf="!infoDetails?.sensitive_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="sensitive_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                                        id="sensitive_words" name="sensitive_words" autocomplete="off"
                                        [disable]="disableInput" [addOnPaste]="true" [pasteSplitPattern]="splitPattern">
                                    </tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Hide Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.hide_keywords">{{infoDetails?.hide_keywords}}</span>
                                        <span *ngIf="!infoDetails?.hide_keywords?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="hide_keywords"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="hide_keywords"
                                        name="hide_keywords" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Delete Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.delete_words">{{infoDetails?.delete_words}}</span>
                                        <span *ngIf="!infoDetails?.delete_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="delete_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="delete_words"
                                        name="delete_words" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Comments</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.conversation">{{infoDetails?.conversation}}</span>
                                        <span *ngIf="!infoDetails?.conversation"><b>-</b></span>
                                    </p>
                                    <textarea *ngIf="infoEditShow" formControlName="conversation" type="text"
                                        class="form-control" placeholder="Enter all audit comment"></textarea>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Language</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection language-form-group">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetailsLanguage}}</p>
                                    <ng-select *ngIf="infoEditShow" [attr.disabled]="true" [readonly]="true"
                                        formControlName="language" type='text' placeholder="Choose Language">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="infoEditShow" (click)="clearRecordData()"
                        class="btn btn-light cancelBtn" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" [disabled]="!infoForm.dirty || infoForm.invalid" *ngIf="infoEditShow"
                        class="btn btn-primary updateBtn" (click)="updateInfoDetails()" data-bs-dismiss="modal"
                        (click)="clearRecordData()">Update</button>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Report Modal -->
    <div class="modal fade reportModalClass" #reportModalContent data-bs-backdrop="static" data-bs-keyboard="false"
        id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="reportModalLabel">Review / Analysis</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="container-fluid">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="reportFirstPart d-flex language-form-group">
                                        <select (change)="changeTranscriptLgReport()"
                                            [(ngModel)]="transcribedLgVariable" name="" id=""
                                            class="form-select lg-select-transcript" *ngIf="showSelect && !spinner">
                                            <option *ngFor="let lg of transcribedLg" [value]="lg">{{lg}}
                                            </option>
                                        </select>
                                        <button class="btn updateBtn" (click)="makePDF()"
                                            [disabled]="downloadBtnSpinner"><i *ngIf="downloadBtnSpinner"
                                                class="fa fa-spinner fa-pulse fa-3x fa-fw download-spinner"></i>
                                            <span class="sr-only">Loading...</span> Download Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row reportSecondPart">
                            <div class="col-md-8 offset-md-3">
                                <table id="report-top-details" class="reportTable" style="display: none;">
                                    <thead style="display: none;">
                                        <tr>
                                            <th colspan="4">Report Details - {{dateTime | date:'shortDate'}} </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td> <label class="form-label first-label"><b>File Uploaded Date
                                                    </b></label> </td>
                                            <td> <span class="form-detail"> {{infoDetails?.updated_date |
                                                    date:'shortDate'}}</span> </td>
                                            <td> <label class="form-label second-label"><b>Call Queue/Topic
                                                    </b></label> </td>
                                            <td> <span> {{infoDetails?.display_file_name}}</span> </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="form-label"><b>File Uploaded Date : </b></label>
                                        <span> {{infoDetails?.updated_date | date:'shortDate'}}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label"><b>Call Queue/Topic : </b></label>
                                        <span> {{infoDetails?.display_file_name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- sss -->
                        <div class="col-md-6 offset-md-3">
                            <div class="card modalCard2" id="sentimentCard2" style="display: none;">
                                <div class="card-header">
                                    <p class="sentiment-header"> Sentiment</p>
                                </div>
                                <table id="sentiment-table-report">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="card-body">
                                                    <ul class="list-group list-group-horizontal">
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.positive_sentiment?.[0] |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Positive</p>
                                                        </li>
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.neutral_sentiment?.[0] |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Neutral</p>
                                                        </li>
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.negative_sentiment?.[0] |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Negative</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!--  -->
                        <div class="row reportThirdPart">
                            <div class="col-md-6 offset-md-3">
                                <div class="card modalCard" id="sentimentCard">
                                    <div class="card-header">
                                        <p class="sentiment-header"> Sentiment</p>
                                    </div>
                                    <div class="card-body">
                                        <ul class="list-group list-group-horizontal">
                                            <li class="list-group-item">
                                                <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.positive_sentiment?.[0] |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Positive</p>
                                            </li>
                                            <li class="list-group-item">
                                                <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.neutral_sentiment?.[0] |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Neutral</p>
                                            </li>
                                            <li class="list-group-item">
                                                <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.negative_sentiment?.[0] |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Negative</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row reportFourthPart">
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Question/Answer
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="questionTab" *ngIf="englishQuestions?.length > 0">
                                            <table id="question-answer-report">
                                                <thead style="display: none;">
                                                    <tr>
                                                        <td colspan="2">Question/Answer</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let question of englishQuestions | search: searchText; index as i">
                                                        <td class="numberTd">{{i+1}}.</td>
                                                        <td>
                                                            <p class="answerPara">
                                                                <b>{{"Q : "}}</b>
                                                                {{question.question}}
                                                            </p>
                                                            <p> <b>{{"A : "}}</b>
                                                                {{question.answer}}</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="questionTab2" *ngIf="englishQuestions?.length == 0">
                                            <p class="noRecord">No Records Found</p>
                                            <table id="question-answer-report" style="display: none;">
                                                <thead>
                                                    <tr>
                                                        <td colspan="2">Question/Answer</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <p class="noRecord">No Records Found</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard keywordPhrasesCard">
                                    <div class="card-header">
                                        Keywords/Phrases
                                    </div>
                                    <div class="card-body keywordTabCardBody">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <table class="keywordTab" id="keyword-phrases-table-report"
                                            *ngIf="keywordPhrases?.length > 0">
                                            <tbody>
                                                <tr
                                                    *ngFor="let keyword of keywordPhrases | search: searchText; index as i">
                                                    <td>
                                                        <li class="keywordLi"
                                                            *ngIf="transcribedLgVariable === 'English' ">
                                                            {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                                        <li class="matchesLi"
                                                            *ngIf="transcribedLgVariable === 'English' ">
                                                            {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1"
                                                                class="text-center">
                                                                No matches were found for keyword -
                                                                "{{keyword.keyword}}"</p>
                                                        </li>
                                                        <li class="keywordLi"
                                                            *ngIf="transcribedLgVariable !== 'English' ">
                                                            {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}
                                                        </li>
                                                        <li class="matchesLi"
                                                            *ngIf="transcribedLgVariable !== 'English' ">
                                                            {{keyword.spanish_matches}} <p
                                                                *ngIf="keyword.spanish_matches?.length < 1"
                                                                class="text-center">No matches were found for
                                                                keyword -
                                                                "{{keyword.spanish_keyword}}"</p>
                                                        </li>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="questionTab2" *ngIf="keywordPhrases?.length == 0">
                                            <p class="noRecord">No Records Found</p>
                                            <table class="keywordTab" id="keyword-phrases-table-report"
                                                style="display: none;">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <p class="noRecord">No Records Found</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard dialogue-text-record-report">
                                    <div class="card-header">
                                        Dialogue
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <table class="table" id="transcriptReport" *ngIf="dialogueList?.[0]">
                                            <thead style="display: none;">
                                                <tr>
                                                    <th>
                                                        Dialogue
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let dialog of dialogueList  | search: searchText; index as i">
                                                    <td class="report-dialog">{{dialog}}</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                        <table class="table" id="transcriptReport" *ngIf="!dialogueList?.[0]">
                                            <thead style="display: none;">
                                                <tr>
                                                    <th>
                                                        Dialogue
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="noRecord text-center">No records
                                                            found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Summary
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="summaryTab">
                                            <p class="data" *ngFor="let sum of keywordSummary | search: searchText">
                                                {{sum}}</p>
                                            <p class="noRecord text-center" *ngIf="!keywordSummary?.length">No
                                                records
                                                found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Most Used Words
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="mostUsedWordTab" *ngIf="mostUsedWords?.length > 0">
                                            <table id="most-used-words-table-report">
                                                <tbody>
                                                    <tr
                                                        *ngFor="let word of mostUsedWords | search: searchText; index as i">
                                                        <td>
                                                            <p class="data">
                                                                {{i+1}}.
                                                                {{word.word}}
                                                                ({{word.count}})</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="questionTab2" *ngIf="mostUsedWords?.length == 0">
                                            <p class="noRecord">No Records Found</p>
                                        </div>
                                        <table id="most-used-words-table-report" style="display: none;">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Most Used Words
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="noRecord">No Records Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 offset-md-3">
        <div class="card modalCard2" id="sentimentCard3" style="display: none;">
            <div class="card-header">
                <p class="sentiment-header"> Sentiment</p>
            </div>
            <table id="sentiment-table-report">
                <tbody>
                    <tr>
                        <td>
                            <div class="card-body">
                                <ul class="list-group list-group-horizontal">
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.positive_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.neutral_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Neutral</p>
                                    </li>
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.negative_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    
   <!-- Sentiment Modal  -->
    <div class="modal fade" id="sentimentModal">
        <div class="modal-dialog modal-dialog-scrollable modal-lg sentimentModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><img src="../../../../assets/images/notes_ai_icon.svg" width="24" height="24">&nbsp; AI Generated Sentiment Summary</h4>
                    <i class="fa-solid fa-xmark exitIcon" (click)="clearSentimentData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="tab-content">
                        
                        <div class="col-12 px-3 py-3">
                            <div class="position-relative">
                                <div class="sentimentIcon">
                                <i class="fa-regular fa-face-meh audioIcons iconMeh" *ngIf="sentimentData.sentiment=='Neutral'" ></i>
                                <i class="fa-regular fa-face-smile audioIcons iconSmile" *ngIf="sentimentData.sentiment=='Positive'" ></i>
                                <i class="fa-regular fa-face-frown audioIcons iconSad" *ngIf="sentimentData.sentiment=='Negative'"></i>
                                </div>
                            </div>
                            <div class="transcriptTab">
                                <p [innerHTML]="sentimentData['sentiment_summary'] | replaceLineBreaks"></p>
                            </div>
                       </div>
                    </div>
                    <!-- email icon section -->
                    <!-- <div class="tab-content" *ngIf="showData == 'emailTable'">
                        <div class="card">
                            <div class="sentiment-container-emoji">
                                <ul class="list-group list-group-horizontal border">
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-smile audioIcons iconSmile" aria-hidden="true"></i>
                                        <p class="sentiment-score">{{sentimentData?.positive_sentiment | number:
                                            '1.1-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-frown audioIcons iconSad" aria-hidden="true"></i>
                                        <p class="sentiment-score">{{sentimentData?.negative_sentiment | number:
                                            '1.1-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>


    <!-- Sentiment Modal  -->
    <div class="modal fade" id="textSummaryModal">
        <div class="modal-dialog modal-dialog-scrollable modal-lg sentimentModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><img src="../../../../assets/images/notes_ai_icon.svg" width="24" height="24">&nbsp; AI Generated Text Summary</h4>
                    <i class="fa-solid fa-xmark exitIcon" (click)="clearSentimentData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="tab-content">
                     
                       


                        
                        <div class="col-12 px-3 py-3">
                           
                            <div class="transcriptTab">
                                <p [innerHTML]="summaryData | replaceLineBreaks"></p>
                            </div>
                       </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>

    <!--Row records Modal-->
     <div class="modal fade" id="rowrecordsModal">
      
        <div class="modal-dialog modal-dialog-scrollable modal-lg sentimentModalWindow full-screen">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Record Data</h4>
                    <i class="fa-solid fa-xmark exitIcon" (click)="clearSentimentData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="tab-content">
                
                           <div class="table-responsive">
                        <div class="tblCrd">
                            <table class="table table-hover text-center" id="xlsTable">
                                <thead class="tblHead">
                                    <tr>
                                        <th *ngFor="let headData of rowRecords[0] | keyvalue">{{headData.key}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let headData of rowRecords; let i=index">
                                        <td *ngFor="let headData of rowRecords[i] | keyvalue">
                                          <span class="text-start" appReadMore [toggle]="true" [limit]="20">  {{headData.value}} </span>
                                        </td>
                                    </tr>
                                         
                                     
                                  
                                    </tbody>
                                  </table>
                                  </div>
                                  </div>
                    </div>
             
                </div>
            </div>
        </div>
    </div>
    <!--Row records Modal-->
   
 
      <!-- Q/A Modal -->
<div class="modal fade " id="qaModal">
    <div class="modal-dialog modal-dialog-scrollable modal-xl sentimentModalWindow" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <img src="../../../../assets/images/notes_ai_icon.svg" width="24" height="24"> &nbsp; AI Generated Question & Answer</h4>
               <span>
                <!-- <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp; -->
              
                    <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
               </span>
            </div>
            <div class="modal-body">
                <div class="tab-content">
                   <div class="transcriptTab">
                    <div class="py-3 px-3">
                    <ng-container *ngIf="QA_Pairs.length > 0">
                    <div class="qa-container" *ngFor="let data of QA_Pairs;let i = index;let odd = odd; let even = even"
        [ngClass]="{'odd-row': odd, 'even-row': even}">
                        
                        <div class="row mt-2">
                            <div class="col">
                        
                                <div class="">
                                    <p><b>Q:&nbsp;&nbsp;</b>{{newLine(data.question)}}</p>
                                    <p *ngIf="data.answer"><b>A:&nbsp;&nbsp;</b>{{newLine(data.answer)}}</p>
                                </div>
                                </div>
                            </div>
                        </div>
                        </ng-container>
                        <div class="d-flex align-items-center justify-content-center mt-2" *ngIf="!QA_Pairs.length">No data found!</div>  
                    </div>
                </div> 
                </div>
            </div>
        </div>
    </div>
</div>
   
  
</div>

<!-- delete modal for Delete table record-->
<div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel">Delete File</h4>
                <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"></i>
            </div>
            <div class="modal-body">
                Are you sure you want to delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                <button type="button" class="btn btn-danger" (click)="deleteSelectRecord(getRecordIndex)"
                    data-bs-dismiss="modal">Yes</button>
            </div>
        </div>
    </div>
</div>